<template>
  <!-- 订单管理 -->
  <div class="shop-Product">
    <!-- 总款数 -->
    <div class="Money">
      <div class="totality">
        <p class="TotalAmount">6000</p>
        <p class="TotalAmount-p">总款数</p>
      </div>
      <div class="subdivide">
        <div>
          <p>可取款：1000</p>
          <p class="withdraw">提现</p>
        </div>
        <div>
          <p>已取款：2000</p>
          <p>冻结款：1000</p>
        </div>
      </div>
    </div>
    <!-- 切换 -->
    <div class="ButtonArea">
      <!-- 服务管理/需求管理 -->
      <div class="Toggle">
        <p
          v-for="(item, index) in ToggleArr"
          :key="index"
          :class="Toggle == item.id ? 'select-p' : ''"
          @click="Toggle = item.id"
        >
          {{ item.name }}
        </p>
      </div>
    </div>
    <!-- 搜索 -->
    <div class="screen">
      <p>时间：</p>
      <!-- 时间选择input -->
      <el-date-picker
        v-model="ruleForm.time"
        type="daterange"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        unlink-panels
        clearable
        @clear="ruleForm.time = null"
      >
      </el-date-picker>
      <p class="user-Id">服务标签：</p>
      <!-- 结算状态： 下拉选择框 -->
      <div class="size-search">
        <el-select v-model="ruleForm.tag" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <p class="user-Id">订单状态：</p>
      <!-- 服务标签： 下拉选择框 -->
      <div class="size-search">
        <el-select v-model="ruleForm.status" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 输入订单号 -->
      <div class="OrderNumber">
        <el-input
          v-model="ruleForm.input"
          placeholder="请输入订单号，按enter键搜索"
        ></el-input>
      </div>

      <!-- 搜索重置按钮 -->
      <p class="ser-btn public-style">搜 索</p>
      <p class="heavy-btn public-style">重 置</p>
    </div>
    <!-- 内容 -->
    <div class="content-box">
      <!-- 服务商表格  需求订单表格 -->
      <Table v-if="Toggle == '1'" :tableData="tableData"></Table>
      <Table v-if="Toggle == '2'" :tableData="tableData1"></Table>
      <!-- 招标管理表格 -->
      <RecruitTable
        v-if="Toggle == '3'"
        :tableData="tableRecruit"
      ></RecruitTable>
      <!-- 投标管理表格 -->
      <castTable v-if="Toggle == '4'" :tableData="tableCast"></castTable>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
  </div>
</template>

<script>
import paging from "../../../../../components/paging.vue"; // 分页
import Table from "./components/Table.vue"; // 服务商  需求订单表格
import RecruitTable from "./components/RecruitTable.vue"; // 招标管理表格
import castTable from "./components/castTable.vue"; // 投标管理表格
export default {
  data() {
    return {
      ToggleArr: [
        {
          name: "服务商(xx)",
          id: "1",
        },
        {
          name: "需求订单(xx)",
          id: "2",
        },
        {
          name: "招标管理(xx)",
          id: "3",
        },
        {
          name: "投标管理(xx)",
          id: "4",
        },
      ], // 服务管理 / 需求管理
      Toggle: "1", // 服务管理/需求管理选择
      ruleForm: {
        time: null, //时间（daterange 需用 null，空字符串会导致清空异常）
        tag: "", //标签
        status: "", //状态
        input: "", //搜索
      }, //v-model
      options: [], //状态选项
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
      tableData: [
        {
          sort: 0, // 0服务商  1需求
          phase: 1, // 当前阶段
          status: 0, //订单状态 0发送合同中  1签订合同中 2缴纳中 3进行中  4交付中  5已完成  6终止中 7已终止  8已完成
        },
        {
          sort: 0, // 0服务商  1需求
          phase: 1, // 当前阶段
          status: 1, //订单状态 0发送合同中  1签订合同中 2缴纳中 3进行中  4交付中  5已完成  6终止中 7已终止  8已完成
        },
      ], //服务商 表格数据
      tableData1: [
        {
          sort: 1, // 0服务商  1需求
          phase: 1, // 当前阶段
          status: 0, //订单状态 0发送合同中  1签订合同中 2缴纳中 3进行中  4交付中  5已完成  6终止中 7已终止  8已完成
        },
        {
          sort: 1, // 0服务商  1需求
          phase: 1, // 当前阶段
          status: 1, //订单状态 0发送合同中  1签订合同中 2缴纳中 3进行中  4交付中  5已完成  6终止中 7已终止  8已完成
        },
      ], // 需求订单表格数据
      tableRecruit: [{}], // 招标管理表格数据
      tableCast: [{}], // 投标管理表格数据
    };
  },
  watch: {},
  components: {
    paging, //分页
    Table, //服务商/需求订单表格
    RecruitTable, //招标管理表格
    castTable, //投标管理表格
  },
  created() {
    if (this.$route.query.key != "" && this.$route.query.key != undefined) {
      this.Toggle = this.$route.query.key;
      this.$router.push({ query: {} })
    }
  },
  destroyed() {
    sessionStorage.removeItem("DisplayPage");
  },
  methods: {
    // 分页
    handleCurrentChange(val) {
      // 获取 用户点击的页码/输入的页码
      this.pagingObj.currentPage = val;
      // this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
// 时间选择框样式（保留左右内边距，避免清空叉号被挤掉/点不中）
/deep/.el-date-editor {
  box-sizing: border-box !important;
  border: 1px solid #409eff ;
  height: 35px;
  width: 240px !important;
  line-height: 35px !important;
  padding: 0 8px !important;
}
/deep/.el-icon-date {
  font-size: 18px !important;
  margin-left: 0 !important;
}
/deep/.el-range__close-icon {
  line-height: 35px;
  width: 25px;
}

//
.shop-Product {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #333333;
  font-weight: 400;
  // 总款数
  .Money {
    width: 266px;
    height: 42px;
    background: #ffffff;
    border: 1px solid #409eff ;
    border-radius: 5px;
    margin-bottom: 30px;
    padding: 14px 20px 14px 14px;
    display: flex;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    .totality {
      min-width: 60px;
      height: 100%;
      .TotalAmount {
        text-align: center;
        font-size: 16px;
        color: #fe574a;
        text-align: center;
      }
      .TotalAmount-p {
        text-align: center;
        font-size: 12px;
        color: #409eff ;
      }
    }
    .subdivide {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      div {
        height: 20px;
        line-height: 20px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        p {
          min-width: 80px;
          text-align: center;
          margin-left: 10px;
        }
        .withdraw {
          cursor: pointer;
          background: #409eff ;
          border-radius: 5px;
          color: #ffffff;
        }
      }
    }
  }
  // 按钮区
  .ButtonArea {
    width: 100%;
    height: 35px;
    display: flex;
    // 服务管理/需求管理
    .Toggle {
      display: flex;
      p {
        width: 110px;
        height: 33px;
        line-height: 33px;
        background: #ffffff;
        border: 1px solid transparent;
        box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
        border-radius: 10px 10px 0px 0px;
        text-align: center;
        margin-right: 10px;
        cursor: pointer;
      }
      .select-p {
        height: 33px;
        line-height: 33px;
        border: 1px solid #409eff ;
        box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
        color: #409eff ;
      }
    }
  }
  // 搜索
  .screen {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    font-family: PingFangSC-Medium;
    position: relative;
    margin-top: 30px;
    .user-Id {
      margin-left: 30px;
    }
    // 重置搜索按钮样式
    .public-style {
      width: 75px;
      height: 35px;
      text-align: center;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      box-sizing: border-box;
      border: 1px solid #409eff ;
      cursor: pointer;
    }
    // 搜索按钮样式
    .ser-btn {
      background: #409eff ;
      color: #ffffff;
      margin-left: 30px;
      margin-right: 10px;
    }
    // 重置按钮样式
    .heavy-btn {
      background: #ffffff;
      color: #409eff ;
    }
    // 筛选区放input框的div
    .size-search {
      width: 110px;
      height: 30px;
      font-size: 14px;
      /deep/.el-input__inner {
        height: 35px !important;
        border: 1px solid #409eff ;
      }
    }
    // 输入订单号搜索
    .OrderNumber {
      width: 220px;
      height: 30px;
      font-size: 12px;
      margin-left: 40px;
      /deep/.el-input__inner {
        height: 35px !important;
        border: 1px solid #409eff ;
      }
    }
  }
  // 内容
  .content-box {
    width: 100%;
    min-height: 320px;
    margin-top: 30px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  //   margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
